"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for Filter component
 */
var Options = /** @class */ (function () {
    /**
     * @param isSingleFilterMode use as a single filter not filter tree(with ANDs , ORs)
     * @param hideItemsSelect if {@code true}  category/measure selection combo will be hidden.
     */
    function Options(isSingleFilterMode, hideItemsSelect) {
        this.isSingleFilterMode = isSingleFilterMode;
        this.hideItemsSelect = hideItemsSelect;
    }
    return Options;
}());
exports.Options = Options;
//# sourceMappingURL=options.js.map